export default "__VITE_ASSET__BnvLsUPr__"